import React, { useEffect, useMemo, useState } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import TicketImage from "./TicketImage";
import classes from "./TicketIntroduction.module.css";
import Description from "../common/Description";
import { useSelector } from "react-redux";
import { STATE_CULTURE } from "../../common/state";

const TicketIntroduction = (props) => {
  const { config, urlParams, ticketData, text } = props;
  const [culture, language] = useSelector((state) => [
    state.cookies[STATE_CULTURE],
    state.language,
  ]);
  const [hideLongText, setHideLongText] = useState(true);

  const filter = ticketData.filter((el) => el.slug.toLowerCase() === urlParams);

  useEffect(() => {
    setHideLongText(false);
  }, [text]);

  const altText = useMemo(() => {
    if (filter && language && culture) {
      return `${language.ImageAltText} ${
        filter?.[0]?.translations?.find((t) => t.culture === culture)?.name
      }`;
    }
  }, [filter, language, culture]);

  const imgUrl = `${config.baseUrl}/ee-static/shop/${config.shopName}/Images/`;

  return (
    <div className={`${classes.ticketWrapper} ticketWrapper`}>
      {filter && filter[0]?.image && (
        <TicketImage
          className="ticketImage"
          imageUrl={`${filter[0].image ? `${imgUrl}${filter[0].image}` : ""}`}
          altText={altText}
        />
      )}
      {filter && filter.length >= 1 ? (
        <div
          className={`ticketTextWrapper ${classes.ticketTextWrapper} ${
            filter[0].image
              ? classes.ticketTextPadding
              : classes.ticketTextPaddingNoImg
          }  `}
        >
          <div>
            <div className={classes.showMore}>
              {text.length > 300 && window.screen.availWidth <= 768 ? (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <ReactMarkdown
                    className={
                      hideLongText === true
                        ? classes.ticketText
                        : classes.ticketTextGradient
                    }
                    rehypePlugins={[rehypeRaw]}
                  >
                    {hideLongText === false
                      ? text.substr(0, 300) + "... "
                      : text}
                  </ReactMarkdown>
                </div>
              ) : (
                <Description text={text} fileName={props.fileName} />
              )}
              {text.length > 300 && window.screen.availWidth <= 768 ? (
                <button
                  className={classes.readMoreButton}
                  style={{ fontSize: "1rem", paddingLeft: 0 }}
                  onClick={() => setHideLongText(!hideLongText)}
                >
                  {hideLongText === false
                    ? language.ReadMore
                    : language.ShowLessText}
                </button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default TicketIntroduction;
